import { Tab } from "@headlessui/react";
import GalleryTab from "./gallery-tab";

const Gallery = ({ images }) => {
  return (
    <Tab.Group as='div' className='flex flex-col w-full h-full'>

      <Tab.Panels className={'w-full h-full'}>
        {images.map((image) => (
          <Tab.Panel key={image} className="w-full h-full">
            <div className="relative sm:rounded-lg overflow-hidden flex justify-center items-center h-full">
              <div className="h-full w-full max-h-[30rem] flex justify-center items-center">
                <img
                  src={image}
                  alt="project"
                  className="w-auto h-full"
                />
              </div>
            </div>
          </Tab.Panel>
        ))}
      </Tab.Panels>

      <div className="mx-auto mt-6 w-full h-1/6 max-w-2xl sm:block lg:max-w-none">
        <Tab.List className={'flex flex-row gap-6'}>
          {images.map((image) => (
            <GalleryTab key={image} image={image} />
          ))}
        </Tab.List>
      </div>

    </Tab.Group>
   );
}

export default Gallery;
